import { render, staticRenderFns } from "./ModalConfigs.vue?vue&type=template&id=d6e4df00&scoped=true&"
import script from "./ModalConfigs.vue?vue&type=script&lang=js&"
export * from "./ModalConfigs.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfigs.vue?vue&type=style&index=0&id=d6e4df00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e4df00",
  null
  
)

export default component.exports